var map = {
	"./skin1/edit_face_yes_highlight@3x.png": "3fd4",
	"./skin2/edit_face_yes_highlight@3x.png": "bb05",
	"./skin3/edit_face_yes_highlight@3x.png": "d671",
	"./skin4/edit_face_yes_highlight@3x.png": "4e2bc",
	"./skin5/edit_face_yes_highlight@3x.png": "a171",
	"./skin6/edit_face_yes_highlight@3x.png": "68bc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "88ad";